export default "__VITE_ASSET__BguLhtl8__"